
import React from 'react';
import { SEO } from '@/components/SEO';
import OptimizedHeroSection from '@/components/home/OptimizedHeroSection';
import CategoryGrid from '@/components/home/CategoryGrid';
import TopGamesSection from '@/components/home/TopGamesSection';
import { useContentFreshness } from '@/hooks/useContentFreshness';
import { useWebsiteSettings } from '@/hooks/useWebsiteSettings';
import ExploreGamesSection from '@/components/home/ExploreGamesSection';
import AdDisplay from '@/components/ads/AdDisplay';

const Home = () => {
  const { data: freshnessData } = useContentFreshness();
  const { settings } = useWebsiteSettings();
  
  // Use dynamic settings for SEO
  const siteName = settings?.site_name || 'TerraGamers';
  const siteDescription = settings?.site_description || 'Discover and play thousands of free online games. Action, puzzle, racing, and more!';
  const metaTitle = settings?.meta_title || `${siteName} - Free Online Games`;
  
  return (
    <>
      <SEO 
        title={metaTitle}
        description={siteDescription}
        keywords={settings?.meta_keywords}
      />
      
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-purple-50/20">
        {/* Header Banner Ad - positioned above hero section */}
        <div className="w-full">
          <AdDisplay position="header" className="w-full" />
        </div>

        {/* Hero Section */}
        <OptimizedHeroSection freshnessData={freshnessData} />
        
        {/* Top Games Section - reduced padding */}
        <section className="py-4 md:py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <TopGamesSection />
          </div>
        </section>

        {/* Explore Games Section - reduced padding */}
        <section className="py-4 md:py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ExploreGamesSection />
          </div>
        </section>

        {/* Categories Grid - reduced padding */}
        <section className="py-4 md:py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <CategoryGrid />
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
